module.exports = __webpack_public_path__ + "img/download_brochure.1ffb882c.jpg";